<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-radio-group class="no_space_vertical" :disabled="preview" v-model="measures.has_desc" label="Presenza prove di scarico">
                        <v-radio label="Presenti" value="on"></v-radio>
                        <v-radio label="Non presenti" value="off"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="6">
                        <v-radio-group class="no_space_vertical" :disabled="preview" v-model="measures.has_zavorra" label="Presenza zavorra">
                        <v-radio label="Presente" value="on"></v-radio>
                        <v-radio label="Non presente" value="off"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="!preview">
                    <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2">
                        <v-btn color="primary" @click="handlePlaceholders()">Riempimento automatico</v-btn>
                    </div>
                </v-row>
                <v-row no-gutters>
                    <span class="subtitle-2"><b>Misure Asc.</b></span>
                </v-row>
                <v-row no-gutters>
                <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.nom}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="checkZavorra">{{data.block.conf.headers.weights}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="checkZavorra">{{data.block.conf.headers.zavorra}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="checkZavorra">{{data.block.conf.headers.total}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.toleranceError}} <br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.result}}</th>
                    </tr>
                    </thead>
                    <tr v-for="(item, index) of measures.items_up" :key="item.index">
                            <td class="table-blocks with_scroll">
                                <v-row no-gutters>
                                    <v-col cols="1">
                                        <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings && !preview" @click="removeRow(index)">delete</v-icon>
                                    </v-col>
                                    <v-col cols="11">
                                        <NumericField dense outlined
                                        v-model="item.mass"
                                        solo hide-details
                                        :readonly="preview"
                                        @input="changeMass(item)"
                                        :precision="currentPrecision"
                                        :class="readingWarning(item.mass)"
                                        />
                                    </v-col>
                                </v-row>
                            </td>
                            <td class="table-blocks with_scroll" v-if="checkZavorra">
                                <NumericField dense outlined
                                v-model="item.sample_masses"
                                solo hide-details
                                :readonly="preview"
                                :precision="currentPrecision"
                                @blur="calcTotal(item)"
                                />
                            </td>
                            <td class="table-blocks with_scroll" v-if="checkZavorra">
                                <NumericField dense outlined
                                v-model="item.zavorra"
                                solo hide-details
                                :readonly="preview"
                                :precision="currentPrecision"
                                @blur="calcTotal(item)"
                                />
                            </td>
                            <td class="table-blocks with_scroll" v-if="checkZavorra">
                                <NumericField dense outlined
                                v-model="item.total"
                                solo hide-details
                                disabled
                                :readonly="preview"
                                :precision="currentPrecision"
                                />
                            </td>
                            <td class="table-blocks with_scroll">
                                <NumericField dense outlined
                                v-model="item.reading"
                                solo hide-details
                                :readonly="preview"
                                @input="changeCementoReading(item, 'up')"
                                :class="readingWarning(item.reading)"
                                :placeholder="readingPlaceholder(item.mass)"
                                :precision="currentPrecision"
                                :enableicons="!preview"
                                :addfunc="readingAddFunc"
                                :subfunc="readingSubFunc"
                                :row="item"
                                :fieldname="'reading'"
                                :range="calcMinRange(item.reading)"
                                />
                            </td>
                            <td class="table-text-blocks text-right">
                                <b>{{item.error | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks text-right">
                                <b>{{item.toleranceError}}</b>
                            </td>
                            <td class="table-text-blocks text-right">
                                <b>{{item.tolerance}}</b>
                            </td>
                            <td class="table-text-blocks text-center">
                                <StatusIcon :status="item.result" 
                                :tooltip_text="row_tooltip[item.result]"/>
                            </td>
                        </tr>
                    </template>
                    </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow_up" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                </div>
            </v-row>
            <div class="d-flex flex-column" v-if="checkDescent">
            <v-row no-gutters>
                <span class="subtitle-2"><b>Misure Disc.</b></span>
            </v-row>
            <v-row no-gutters>
                <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.nom}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="checkZavorra">{{data.block.conf.headers.weights}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="checkZavorra">{{data.block.conf.headers.zavorra}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="checkZavorra">{{data.block.conf.headers.total}}  <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.toleranceError}} <br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{computeToleranceType.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.result}}</th>
                    </tr>
                    </thead>
                    <tr v-for="(item,index) of measures.items_down" :key="item.index">
                        <td class="table-blocks with_scroll">
                            <NumericField dense outlined
                            v-model="item.mass"
                            hide-details disabled
                            :precision="currentPrecision"
                            />
                        </td>
                        <td class="table-blocks with_scroll" v-if="checkZavorra">
                            <NumericField dense outlined
                            v-model="item.sample_masses"
                            solo hide-details
                            :readonly="preview"
                            :precision="currentPrecision"
                            @blur="calcTotal(item)"
                            />
                        </td>
                        <td class="table-blocks with_scroll" v-if="checkZavorra">
                            <NumericField dense outlined
                            v-model="item.zavorra"
                            solo hide-details
                            :readonly="preview"
                            :precision="currentPrecision"
                            @blur="calcTotal(item)"
                            />
                        </td>
                        <td class="table-blocks with_scroll" v-if="checkZavorra">
                            <NumericField dense outlined
                            v-model="item.total"
                            solo hide-details
                            disabled
                            :readonly="preview"
                            :precision="currentPrecision"
                            />
                        </td>
                        <td class="table-blocks with_scroll">
                            <NumericField dense outlined
                            v-model="item.reading"
                            solo hide-details
                            :readonly="preview"
                            @input="changeCementoReading(item, 'down')"
                            :class="readingWarning(item.reading, currMaxRange)"
                            :placeholder="readingPlaceholder(item.mass)"
                            :precision="currentPrecision"
                            :enableicons="!preview"
                            :addfunc="readingAddFunc"
                            :subfunc="readingSubFunc"
                            :row="item"
                            :fieldname="'reading'"
                            :range="currMaxRange"
                            />
                        </td>
                        <td class="text-right table-text-blocks">
                            <b>{{item.error | formatNumber}}</b>
                        </td>
                        <td class="table-text-blocks text-right">
                            <b>{{item.toleranceError}}</b>
                        </td>
                        <td class="text-right table-text-blocks">
                            <b>{{item.tolerance}}</b>
                        </td>
                        <td class="table-text-blocks text-center">
                            <StatusIcon 
                            :status="item.result"
                            :tooltip_text="row_tooltip[item.result]" />
                        </td>
                    </tr>
                </template>
                </v-simple-table>
            </v-row>
            </div>
            <v-row no-gutters v-if="checkDescent">
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow_down" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                </div>        
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2">
                    <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                </div>
            </v-row>
            </v-container>
        </div>
    </LayoutBlock>
</template>
<script>
import {cemento_item} from "../../../utils/itemBlockSchema"
import {BaseIsoSimple} from "../../../utils/baseIsoSimple"
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from "../../../components/utils/StatusIcon"
// import _ from 'lodash'
import Big from "big.js"

export default {
    components: {LayoutBlock, StatusIcon},
    mixins:[BaseIsoSimple],
    data(){
        return{
            pagination: {'rowsPerPage': -1},
            items: [],
            tutorial_dialog: {
                dialog: false,
                message: "Tutorial per la linearità nawi"
            },
            currMaxRange: null,
        }
    },

    computed: {
        
        precision_overflow(){
            if(this.measures){
                return this.precision_overflow_up && this.precision_overflow_down
            } else {
                return false
            }
        },
        precision_overflow_up() {
            if(this.measures){
                for (let elm of this.measures.items_up) {
                    let res = this.checkReading(elm.reading)
                    switch (res) {
                        case 'uncomplete':
                        case 'done':
                            break
                        case 'failed':
                            return true
                    }
                }
            }
            return false
        },
        precision_overflow_down() {
            if(this.measures){
                for (let elm of this.measures.items_down) {
                    let res = this.checkReading(elm.reading)
                    switch (res) {
                        case 'uncomplete':
                        case 'done':
                            break
                        case 'failed':
                            return true
                    }
                }
            }
            return false
        },
        checkDescent(){
            if(this.measures && this.measures.has_desc){
                if(this.measures.has_desc == "on") {
                    return true
                }
            }
            return false
        },
        checkZavorra(){
            if(this.measures && this.measures.has_zavorra){
                if(this.measures.has_zavorra == "on"){
                    return true
                } 
            }
            return false
        }
    },
    methods: {
        addRow(){
            let item = cemento_item({
                index: this.measures.startingIndex,
                tolerance: this.measures.tolerance
            })
            let item_down = cemento_item({
                index: this.measures.startingIndex,
                tolerance: this.measures.tolerance
            })
            this.measures.items_down.unshift(item_down)
            this.measures.items_up.push(item)
            this.measures.startingIndex++
        },

        async buildMeasures(){
            this.measures = {
                items_up: [],
                items_down: [],
                zero_device: "out",
                hi_res: "off",
                weightTotal: 0,
                startingIndex: 0,
                has_desc: "on",
                has_zavorra: "off",
                result: 'uncomplete',
                tolerance: null,
                toleranceData: null
            }
            this.buildTolerances()
            this.measures.startingIndex = this.data.block.conf.min_readings
            let catVals = await this.buildWithCategory()
            if(catVals){
                for (let i = 0; i< catVals.length; i++ ){
                    let currCatVal = catVals[i]
                    let item = cemento_item({
                        index: i,
                        mass: currCatVal,
                        tolerance: this.measures.tolerance
                    })
                    let item_down = cemento_item({
                        index: i,
                        mass: currCatVal,
                        tolerance: this.measures.tolerance
                    })
                    this.measures.items_up.push(item)
                    this.measures.items_down.unshift(item_down)
                }
            } else {
                for (let i = 0; i< this.data.block.conf.min_readings; i++ ){
                    let item = cemento_item({
                        index: i,
                        mass: "0",
                        tolerance: this.measures.tolerance
                    })
                    let item_down = cemento_item({
                        index: i,
                        mass: "0",
                        mpe: this.measures.tolerance
                    })
                    this.measures.items_up.push(item)
                    this.measures.items_down.unshift(item_down)
                }
            }
        },
        findRow(items, index){
            return items.find(function(a){
                return a.index == index
            })
        },

        calculateMaxRange(){
            let maxItem = this.measures.items_up.reduce((acc, val) => {
                acc = ( acc === undefined || Big(val.reading).gt(acc.reading)) ? val : acc
                return acc;
            }, {reading: 0})
            // console.log("$$ DEBUG maxRange", maxItem)
            this.currMaxRange = this.calcMinRange(maxItem.reading)
        },
        changeMass(row){
            if(row.mass && row.mass != ""){
                if(this.checkDescent){
                    let row_down = this.findRow(this.measures.items_down, row.index)
                    row_down.mass = row.mass
                    this.calcError(row_down)
                }
                this.calcError(row)
            } else {
                row.result = "uncomplete"
            }
        },
        calcError(row){
            if(row){
                if(this.checkZavorra){
                    if(row.reading && row.reading != ""){
                        row.error = this.differenceInt(row.reading, row.total)
                        row.toleranceError = this.handleToleranceError(row, "cemento")
                        this.calculateResultTolerance(row)
                    } else {
                        row.result = "uncomplete"
                    }
                } else {
                    if (row.reading && row.reading != ""){
                        row.error = this.differenceInt(row.reading, row.mass)
                        row.toleranceError = this.handleToleranceError(row, "cemento")
                        this.calculateResultTolerance(row)
                    } else {
                        row.result = "uncomplete"
                    }
                }
            }
        },
        changeCementoReading(item, dir){
            this.changeLinearityReading(item, dir)
            this.calcError(item)
        },
        changeCementoLoad(item,dir){
            this.changeLinearityAddLoad(item, dir)
            this.calcError(item)
        },
        calcDiff(){
        },
        calcTotal(row){
            if(row.sample_masses && row.zavorra){
                row.total = this.round(Big(row.sample_masses).plus(row.zavorra))
            }
        },
        convertPlaceholders(items){
            for(let item of items){
                item.reading = this.checkZavorra ? item.total : item.mass
            }
        },
        handlePlaceholders(){
            this.convertPlaceholders(this.measures.items_up)
            this.convertPlaceholders(this.measures.items_down)
            for(let item of this.measures.items_up){
                this.calcError(item)
            }
            for(let item of this.measures.items_down){
                this.calcError(item)
            }
        },
        removeRow(index){
            // console.log("$$ remove row", index, this.measures.items_down.length - index - 1, this.measures.items_down)
            let item = this.measures.items_up.splice(index,1)
            this.measures.items_down.splice(this.measures.items_down.length - index - 1,1)
            console.log(item)
        },
        calcBlockResult() {
            // console.log('CALC BLOCK RESULT')
            let result_up = 'done'
            result_up = this.measures.items_up.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            let result_down = 'done'
            if(this.checkDescent){
                result_down = this.measures.items_down.reduce(function(result, item){
                    let res = 'done'
                    switch (item.result) {
                        case 'uncomplete':
                            res = 'uncomplete'
                            break
                        case 'failed':
                            if (result == 'uncomplete') {
                                res = 'uncomplete'
                            } else {
                                res = 'failed'
                            }
                            break
                        case 'done':
                            res = result
                            break
                    }
                    return res
                }, 'done')
            }
            // console.log('CALC BLOCK RESULT', result_up, result_down)
            if (result_up == result_down && result_up == "done") {
                if(this.precision_overflow_up || this.precision_overflow_down){
                    this.measures.result = 'failed' 
                } else {
                    this.measures.result = result_up
                }
            }  else if (result_up == 'uncomplete' || result_down == 'uncomplete') {
                this.measures.result = 'uncomplete'
            } else if (result_up == 'failed' || result_down == 'failed') {
                this.measures.result = 'failed'
            }
            // console.log('CALC BLOCK RESULT', result_up, result_down, this.measures.result)
        },

    }

}
</script>
